module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"alphabet":"abcdefghijklmnopqrstuvwxyzæøå"},"en":{"alphabet":"abcdefghijklmnopqrstuvwxyz"}}')
  delete Component.options._Ctor
}
